module.exports = "<span class=\"fa\" data-bind=\"css: type, style: {fontSize: size, color: color, padding: padding}\"></span>";


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/index.html
// module id = 446
// module chunks = 0